// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function isConfigureEventWithResourceConfig(payload) {
    return payload.event === 'configure';
}

export { isConfigureEventWithResourceConfig };
//# sourceMappingURL=isConfigureEventWithResourceConfig.mjs.map
